import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200 py-4 mt-8">
      <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between">
        {/* Left side */}
        <p className="text-gray-600 text-sm">
          © 2026 AquaMind AI Pte. Ltd. All rights reserved.
        </p>
        
        {/* Right side links */}
        <div className="flex space-x-4 text-sm mt-2 md:mt-0">
          <Link to="/privacy" className="text-gray-600 hover:text-blue-600" > Privacy Policy </Link>
          <Link to="/terms" className="text-gray-600 hover:text-blue-600" > Terms of Service </Link>
        </div>
      </div>
    </footer>
  );
}
